<template>
  <div class="dispatch-map">
    <div class="tencent-map">
      <div id="container">
        <div class="map-center-box">
          <div class="chatting">
            <van-loading size="14" v-if="getCenterLoading">加载中...</van-loading>
            <span v-else>{{mapCenterInfo.title}}</span>
          </div>
          <van-image
            width="22"
            height="39"
            :src="require(queryParams.type&&queryParams.type==1?'/src/assets/image/start-addr-icon.png':'/src/assets/image/end-addr-icon.png')"
          />
        </div>
      </div>
      <div class="tencent-map-footer">
        <div class="tip">
          <div class="tip-icon flex-center">
            <img :src="require('/src/assets/image/icon-assure.png')" style="width: 14px;height: 18px;" alt="">
          </div>
          定位如不准确请拖动地图进行调整
        </div>
        <div class="position" @click="handlePositionPhone">
          <img :src="require('/src/assets/image/position.png')" style="width: 16px;height: 16px;" alt="" v-if="positionIcon === 'position'">
          <img :src="require('/src/assets/image/position-checked.png')" style="width: 16px;height: 16px;" alt="" v-if="positionIcon === 'position-checked'">
          <van-loading size="16" color="#669EE6" v-if="positionIcon === 'loading'" />
        </div>
      </div>
    </div>
    <address-info ref="addressInfo" :mapCenterInfo="mapCenterInfo" :openSearch.sync="openSearch" :queryParams.sync="queryParams" />
    <search-list ref="searchList" :map="map" :locationPhoneInfo="locationPhoneInfo" :showIdentification.sync="showIdentification" :getCenterLoading.sync="getCenterLoading" :mapCenterInfo.sync="mapCenterInfo" :openSearch.sync="openSearch" :queryParams="queryParams" @getMapCenter="getMapCenter" />
    <address-identification :showIdentification.sync="showIdentification" ref="addressIdentification" @confirm="identificationConfirm" />
  </div>
</template>

<script>
import { geocoder  } from '@/api/dispatch/index.js';
import addressInfo from './components/address-info.vue';
import searchList from './components/search-list.vue';
import addressIdentification from './components/address-identification.vue';
import { Image , Loading , Search } from 'vant';
import{ plusReady } from '@/utils/index.js';

export default {
  components:{ 
    addressInfo , 
    searchList,
    addressIdentification,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Search.name]: Search,
   },
  data(){
     return {
      map:null,
      mapZoomAntiShakeTimer:null,  //地图缩放防抖计时器
      mapCenterInfo:{},  //当前地图中心数据
      getCenterLoading:false,  //获取中心点loading
      openSearch:false,  //地址搜索栏
      showIdentification:false,  //显示地址识别框
      //手机当前位置
      locationPhoneInfo:{
        province:'',  //省
        city:'',  //市
        district:'',  //区
        detailedAddress:'',  //详细地址
        title:'',  //标题
        latitude:'',
        longitude:'',
      },
      queryParams:{
        id:null,
        province:'',
        city:'',
        district:'',
        detailedAddress:'',
        phoneNumber:'',
        factoryName:'',
        realName:'',
        remark:'',
        title:'',
        latitude:'',
        longitude:'',
        type:1,
        adcode:''
      },
      positionIcon: 'position'
    }
  },
  watch:{
    mapCenterInfo:{
      handler(val){
        Object.assign(this.queryParams,val);
      },
      deep:true,
      immediate:true
    }
  },
  beforeCreate(){
    let pagesTital = '';
    let query = this.$route.query;
    if(query.id) pagesTital = `编辑${query.type==1?'提货地':'交货地'}`;
    else pagesTital = `新增${query.type==1?'提货地':'交货地'}`;
    document.title = pagesTital;
  },
  created(){
    this.initData();
  },
  async mounted(){
    await this.createMap();
    this.initMap();
  },
  methods:{
    /** 数据初始化 */
    initData(){
      let query = this.$route.query;
      this.queryParams = {
        id:query.id?query.id:null,
        phoneNumber:query.phoneNumber?query.phoneNumber:'',
        factoryName:query.factoryName?query.factoryName:'',
        realName:query.realName?query.realName:'',
        remark:query.remark?query.remark:'',
        type:query.type?query.type:1,
        adcode:query.adcode?query.adcode:''
      };
      if(query.hqOrderNo) this.queryParams.hqOrderNo = query.hqOrderNo
      this.mapCenterInfo = {
        province:query.province?query.province:'',
        city:query.city?query.city:'',
        district:query.district?query.district:'',
        detailedAddress:query.detailedAddress?query.detailedAddress:'',
        title:query.title?query.title:'',
        latitude:query.latitude?query.latitude:'',
        longitude:query.longitude?query.longitude:'',
        adcode:query.adcode?query.adcode:''
      };
    },
    /** 地址识别确认 */
    identificationConfirm(params){
      Object.assign(this.queryParams,{
        realName:params.realName,
        phoneNumber:params.phoneNumber,
        factoryName:params.factoryName,
        remark:params.remark
      })
      this.openSearch = true;
      this.$nextTick(()=>{
        this.$refs['searchList'].searchValue = params.detailedAddress.replace(/\s/g,'');
        this.$refs['searchList'].getList();
      })
    },
    handleGetLocationFinally(){
      return new Promise(resolve => {
        this.handleGetLocation()
        .then(position => {
          if(!position.lat || !position.lng || position.lat == 5e-324 || position.lng == 5e-324 ) {
            resolve();
          }else {
            resolve(position);
          }
        }).catch(error => {
          console.log("handleGetLocationFinally catch",error)
          resolve();
        })
      })
    },
    async initMap(){
        if(this.map) return ;
        let query = this.$route.query;
        let LatLng = {};
        let isLocationPhone = false;
        let mapOptions = {
          rotation: 0,//设置地图旋转角度
          pitch: 0, //设置俯仰角度（0~45）
          zoom: 17,//设置地图缩放级别
          center: null,//设置地图中心点坐标
        }
        if(query.latitude && query.longitude) {
          LatLng = { latitude:query.latitude , longitude:query.longitude };
        }else if(query.locationPhoneLat && query.locationPhoneLng && !(query.locationPhoneLat === '22.543099' && query.locationPhoneLng === '114.057868')) {
          LatLng = { latitude:query.locationPhoneLat , longitude:query.locationPhoneLng };
          isLocationPhone = true;
        }else {
          await plusReady();
          let res = await this.handleGetLocationFinally();
          if(res.lat && res.lng) {
            LatLng = { latitude: res.lat , longitude: res.lng };
          }else {
            LatLng = { latitude: '22.543099' , longitude: '114.057868' };
          }
          isLocationPhone = true;
        };
        if(query.detailedAddress && ~query.detailedAddress.indexOf('越南')) mapOptions.zoom = 13;
        mapOptions.center = new window.TMap.LatLng(LatLng.latitude, LatLng.longitude);
        //初始化地图
        this.map = new window.TMap.Map("container", mapOptions);
        this.map.on('zoom',this.mapZoom);
        this.map.on('dragend',this.mapDragend);
        this.$refs['searchList'].mountPanend(this.map);
        if(isLocationPhone) {
          this.getMapCenter()
          .then(result=>{
            this.locationPhoneInfo = {
              province:result.address_component.province,  //省
              city:result.address_component.city,  //市
              district:result.address_component.district,  //区
              detailedAddress:result.pois[0].address,  //详细地址
              title:result.pois[0].title,  //标题
              adcode:result.pois[0].ad_info.adcode,
              latitude:result.location.lat,
              longitude:result.location.lng,
            }
          })
        }
    },
    // 地图缩放事件
    mapZoom(){
      if(this.mapZoomAntiShakeTimer){
          clearTimeout(this.mapZoomAntiShakeTimer);
          this.mapZoomAntiShakeTimer = null;
      }
      this.mapZoomAntiShakeTimer = setTimeout(()=>this.getMapCenter(),200)
    },
    // 地图拖拽交互结束时触发
    mapDragend(){
      this.getMapCenter();
      this.positionIcon = 'position';
    },
    async getMapCenter(options){
      try {
        this.getCenterLoading = true;
        let lat,lng;
        if(options&&options.LatLng) {
          lat = options.LatLng.lat;
          lng = options.LatLng.lng;
        }else {
          let centerData = this.map.getCenter();
          lat = centerData.lat;
          lng = centerData.lng;
        }
        let { result } = await geocoder({location:`${lat},${lng}`,get_poi:1,poi_options:'policy=1'});
          if(!result.pois.length) {
            this.mapCenterInfo = {
                province:'',  //省
                city:'',  //市
                district:'',  //区
                detailedAddress:'',  //详细地址
                title:'移动以获取位置',  //标题
                latitude:result.location.lat,
                longitude:result.location.lng,
                adcode:'',
            };
            this.getCenterLoading = false;
            return Promise.reject(result)
          }
          if(!(options&&options.notSetCenterInfo)){
            this.mapCenterInfo = {
              province:result.address_component.province,  //省
              city:result.address_component.city,  //市
              district:result.address_component.district,  //区
              detailedAddress:result.pois[0].address,  //详细地址
              title:result.pois[0].title,  //标题
              adcode:result.pois[0].ad_info.adcode,
              latitude:result.location.lat,
              longitude:result.location.lng,
            };
          }
        this.getCenterLoading = false;
        return Promise.resolve(result)
    } catch (error) {
        this.getCenterLoading = false;
        return Promise.reject(error);
    }
    },
    async handlePositionPhone(){
      try {
        if(['loading','position-checked'].includes(this.positionIcon)) return;
        this.positionIcon = 'loading';
        let position = await this.handleGetLocation();
        if(!position.lat || !position.lng || position.lat == 5e-324 || position.lng == 5e-324 ) {
          this.positionIcon = 'position';
          return this.$dialog.confirm({
            title:'权限提示',
            message:'请在手机中开启定位信息权限',
          }).then(()=>permission.goSystemAppSetting(),()=>{});
        };
        this.map.panTo(new window.TMap.LatLng(position.lat, position.lng));
        await this.$sleep(500);
        this.getMapCenter();
        this.positionIcon = 'position-checked';
      } catch (error) {
        this.positionIcon = 'position';
        this.$dialog.confirm({
          title:'权限提示',
          message:'请在手机中开启定位信息权限',
        }).then(()=> permission.goSystemAppSetting()).catch(()=>{})
        console.log('position error',error && JSON.stringify(error))
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .dispatch-map {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .tencent-map {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      position: relative;
      #container {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        .map-center-box {
          position: absolute;
          left: 50%;
          bottom: 50%;
          transform: translateX(-50%);
          z-index: 9;
          display: flex;
          flex-direction: column;
          align-items: center;
          .chatting {
            box-sizing: border-box;
            // background: url('/src/assets/image/chatting.png') no-repeat left top;
            min-height: 40px;
            overflow: hidden;
            background: url('../../assets/image/chatting.png') no-repeat left top;
            background-size: 100% 100%;
            padding: 10px 10px 16px 10px;
            font-size: 14px;
            word-break: keep-all;
          }
        }
      }
      .tencent-map-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 8px;
        left: 12px;
        right: 12px;
        z-index: 9999;
        .tip {
          height: 32px;
          box-sizing: border-box;
          font-size: 16px;
          line-height: 28px;
          color: #12A666;
          box-shadow: 2px 2px 4px 1px rgba(8,55,35,0.16);
          background: #F2FCF4;
          border-radius: 8px;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding: 0px 8px 0px 2px;
          font-weight: bold;
          .tip-icon {
            width: 28px;
            height: 28px;
            border-radius: 7px;
            background: linear-gradient( 180deg, #A9D58B 0%, #6AC6A2 100%);
            margin-right: 8px;
            .iconfont {
              // font-size: 18px;
              color: #FFF;
            }
          }
        }
        .position {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          box-shadow: 2px 2px 4px 1px rgba(8,55,35,0.16);
          background-color: #FFF;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          &:active {
            background-color: #F8F8F8;
          }
        }
      }
    }
    ::v-deep a {
      display: none;
    }
    ::v-deep .logo-text {
      display: none;
    }
  }
  
</style>